const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyMaintainSmallIconIi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 11.2,
    fill: "#181A1E",
    style: {
      fill: "#181A1E",
      fill: "color(display-p3 0.0941 0.1020 0.1176)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8799 25.7451C36.4659 25.7451 36.1299 25.4091 36.1299 24.9951V23.4811C36.1299 21.8381 34.7919 20.5001 33.1469 20.5001H31.9419C31.5279 20.5001 31.1919 20.1641 31.1919 19.7501C31.1919 19.3361 31.5279 19.0001 31.9419 19.0001H33.1469C35.6189 19.0001 37.6299 21.0111 37.6299 23.4811V24.9951C37.6299 25.4091 37.2939 25.7451 36.8799 25.7451Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6201 25.7451C19.2061 25.7451 18.8701 25.4091 18.8701 24.9951V23.4811C18.8701 21.0111 20.8811 19.0001 23.3531 19.0001H24.5891C25.0031 19.0001 25.3391 19.3361 25.3391 19.7501C25.3391 20.1641 25.0031 20.5001 24.5891 20.5001H23.3531C21.7081 20.5001 20.3701 21.8381 20.3701 23.4811V24.9951C20.3701 25.4091 20.0341 25.7451 19.6201 25.7451Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1469 37.7607H31.9419C31.5279 37.7607 31.1919 37.4247 31.1919 37.0107C31.1919 36.5967 31.5279 36.2607 31.9419 36.2607H33.1469C34.7919 36.2607 36.1299 34.9227 36.1299 33.2787V29.9551H20.3699V33.2787C20.3699 34.9227 21.7079 36.2607 23.3529 36.2607H24.5889C25.0029 36.2607 25.3389 36.5967 25.3389 37.0107C25.3389 37.4247 25.0029 37.7607 24.5889 37.7607H23.3529C20.8809 37.7607 18.8699 35.7497 18.8699 33.2787V29.9551H17.75C17.336 29.9551 17 29.6191 17 29.2051C17 28.7911 17.336 28.4551 17.75 28.4551H19.5747C19.5896 28.4542 19.6047 28.4537 19.6199 28.4537C19.6351 28.4537 19.6501 28.4542 19.6651 28.4551H36.8347C36.8496 28.4542 36.8647 28.4537 36.8799 28.4537C36.8951 28.4537 36.9102 28.4542 36.9251 28.4551H38.75C39.164 28.4551 39.5 28.7911 39.5 29.2051C39.5 29.6191 39.164 29.9551 38.75 29.9551H37.6299V33.2787C37.6299 35.7497 35.6189 37.7607 33.1469 37.7607Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyMaintainSmallIconIi);
export default __webpack_public_path__ + "static/media/why-maintain-small-icon-ii.2b20e11c87b38d88e63e45f8a1de37bb.svg";
export { ForwardRef as ReactComponent };